/** 个人中心左侧导航菜单（key 与子路由 path 一致，见 routes.js） */
export const MENU_LIST = [
  { key: 'basic', label: '基本信息' },
  { key: 'orders', label: '我的订单' },
  { key: 'invoice', label: '发票中心' },
  { key: 'title', label: '抬头管理' },
];

/** 订单 tab：payStatus 0=待支付 1=已支付 2=已取消(已失效) */
export const ORDER_TABS = [
  { key: 'all', label: '全部订单', payStatus: null },
  { key: 'pending', label: '待支付', payStatus: 0 },
  { key: 'paid', label: '已支付', payStatus: 1 },
  { key: 'expired', label: '已失效', payStatus: 2 },
];

/** 支付状态枚举，对应后端 payStatus */
export const PAY_STATUS = {
  PENDING: 0,
  PAID: 1,
  CANCELLED: 2,
  REFUNDED: 3,
};

/** 订阅 UI 常量，与 subscriptionService.js 保持单一来源 */
export {
  SERVICE_STATUS,
  VIEW_MODE,
  SUBSCRIPTION_VIEW_MODE,
} from '@/view/user/subscriptionService/subscriptionService';

/** 抬头类型：0个人 1企业 */
export function invoiceTitleTypeText(invoiceType) {
  return Number(invoiceType) === 0 ? '个人' : '企业';
}



// WEBPACK FOOTER //
// ./src/view/client/personal-center/config.js